export default __webpack_public_path__ + "static/media/greencheck.9eb56d71.svg";